export enum PrintSampleScope {
  Salary13th = "salary13th",
  KpiIndividual = "kpiIndividual",
  KpiDepartment = "kpiDepartment",
}

export interface PrintSampleCreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}

export interface PrintSample {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
  status: number;
  createdBy: PrintSampleCreatedBy | null;
  updatedBy?: PrintSampleCreatedBy | null;
  name: string;
  nativeName?: string;
  description?: string;
  nativeDescription?: string;
  fileName: string;
  groupBy?: string;
}

export interface PrintSampleListParams {
  page?: number | null;
  limit?: number | null;
  id?: string | null;
  status?: number | null;
  keyword?: string | null;
  select?: string[] | null;
}

export interface PrintSamplePayload {
  name: string;
  fileName: string;
  nativeName?: string;
  description?: string;
  nativeDescription?: string;
  groupBy?: string;
}
